import React from 'react';
import { cn } from '@/lib/utils';
import { LinkInterface } from '@/types';
import NavLink from './NavLink';
import { DateTime } from 'luxon';

interface BannerProps {
  enabled: boolean;
  tag?: string;
  text: string;
  includeCta: boolean;
  cta?: LinkInterface | null;
  startDateTime?: string;
  endDateTime?: string;
}

const TopBanner: React.FC<BannerProps> = ({
  enabled = false,
  tag = '',
  text = '',
  includeCta = false,
  cta = null,
  startDateTime,
  endDateTime,
}) => {
  // Convert UTC times to Eastern and handle current time
  const now = DateTime.now().setZone('America/New_York');
  const start = startDateTime
    ? DateTime.fromISO(startDateTime, { zone: 'America/New_York' })
    : null;
  const end = endDateTime ? DateTime.fromISO(endDateTime, { zone: 'America/New_York' }) : null;

  const isWithinTimeRange = (!start || now >= start) && (!end || now <= end);

  // Early return if banner should not be shown
  if (!enabled || !isWithinTimeRange) return null;

  return (
    <div
      className='bg-element-top-banner bg-blue-950 bg-contain bg-[-10px] bg-no-repeat'
      role='banner'
      aria-label='Site announcement'
      id='top-banner'
    >
      <div className='mx-auto flex max-w-[282px] items-center justify-center space-x-2 p-4 sm:max-w-6xl'>
        <p className='font-halyarddisplay text-center text-base font-normal leading-5 text-white'>
          {tag && <span>{tag.trim()}: </span>}
          <span>{text.trim()} </span>
          {includeCta && cta && (
            <NavLink
              {...cta}
              className={cn(
                'font-medium underline',
                'hover:text-gray-200 focus:outline-none focus:ring-2 focus:ring-white',
              )}
            >
              {cta.label}
            </NavLink>
          )}
        </p>
      </div>
    </div>
  );
};

export default TopBanner;
